// extracted by mini-css-extract-plugin
export default {"home_footer":"Footer_home_footer__AVg3G","footer_social":"Footer_footer_social__iTcwZ","footer_right":"Footer_footer_right__hOd0O"};